module.exports = __webpack_public_path__ + "img/icon-team-builder.8a1a6a17.svg";